import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getCollectionKey, getCollectionsKey, getUpdateCollectionKey, } from '../../utils/keys';
export const useUpdateCollection = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation((input) => client.collections.update(input), {
        onSettled: (data, error, variables) => {
            const collectionKey = getCollectionKey({ id: variables.id });
            queryClient.invalidateQueries(collectionKey);
            const collectionsKey = getCollectionsKey();
            queryClient.invalidateQueries(collectionsKey);
        },
        mutationKey: getUpdateCollectionKey(),
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateCollection.js.map